import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import icons from "../../../assets/images/constantIcons";
import { updateComboOffer } from "./ComboSlice";
import { handleError } from "../../Common/ApiCommon/ApiService";
import { getItemsDetails } from "../Items/ItemsSlice";
import Select from "react-select";


const EditCombos = ({ isOpen, onClose, comboData }) => {
  const dispatch = useDispatch();
  const [imagePreview, setImagePreview] = useState(null);
  const [selectedItemIds, setSelectedItemIds] = useState([]);
  const { items = [], loading } = useSelector((state) => ({
    items: state.items.items,
  }));


  const itemOptions = items?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  useEffect(() => {
    dispatch(getItemsDetails());
  }, [dispatch]);


  // useEffect(() => {
  //   if (comboData?.combo_items && items.length) {
  //     const ids = comboData.combo_items
  //       .map(name => {
  //         const item = items.find(i => i.name === name);
  //         return item ? item.id : null;
  //       })
  //       .filter(id => id !== null);
  //     setSelectedItemIds(ids);
  //   }
  // }, [comboData, items]);

  useEffect(() => {
    if (comboData && comboData.combo_items && items.length > 0) {
      const ids = comboData.combo_items
        .map(name => {
          const item = items.find(i => i.name === name);
          return item ? item.id : null;
        })
        .filter(id => id !== null);

      setSelectedItemIds(ids);

      // Also update formik field when both are ready
      formik.setFieldValue("combo_items", ids);
    }
  }, [comboData, items]);

  useEffect(() => {
    if (comboData?.image_url) {
      setImagePreview(`https://headquater.pixoatic.com${comboData.image_url}`);
    } else {
      setImagePreview(null);
    }
  }, [comboData]);

  const formik = useFormik({
    enableReinitialize: true, // reinitialize when comboData changes
    initialValues: {
      name: comboData?.combo_offer_name || "",
      description: comboData?.combo_description || "",
      combo_items: selectedItemIds || [],
      price: comboData?.price || "",
      status: comboData?.status || "Active",
      image: null,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Combo name is required"),
      price: Yup.number()
        .typeError("Price must be a number")
        .positive("Must be positive")
        .required("Price is required"),
      status: Yup.string().required("Status is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const formData = new FormData();
        formData.append("canteen_combo_offer[combo_offer_name]", values.name);
        formData.append("canteen_combo_offer[combo_description]", values.description);
        formData.append("canteen_combo_offer[price]", values.price);
        formData.append("canteen_combo_offer[status]", values.status.toLowerCase());
        if (values.image) {
          formData.append("canteen_combo_offer[combo_offer_image]", values.image);
        }
        formik.values?.combo_items?.forEach((id) => {
          formData.append("canteen_combo_offer[combo_item_ids][]", id);
        });

        const response = await dispatch(updateComboOffer({ id: comboData.id, formData })).unwrap();
        onClose();
        toast.success(response.message, { duration: 2000 });
        console.log("meesff", response.message);

      } catch (errors) {
        handleError(errors)
      } finally {
        setSubmitting(false);
      }
    },
  });

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      formik.setFieldValue("image", file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-4 s:p-6 w-[310px] s:w-[350px] md:w-[460px] relative">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Edit Combos</h2>
          <div
            className="absolute top-7 right-3 bg-green50 rounded-full p-2 cursor-pointer w-[32px] h-[32px]"
            onClick={onClose}
          >
            <icons.IoClose className="text-green700" />
          </div>
        </div>

        <form
          onSubmit={formik.handleSubmit}
          className="space-y-4 h-[70vh] overflow-y-auto vertical text-start"
        >
          <div className="text-G300">
            <label className="block text-sm mb-2">Combo Name</label>
            <input
              type="text"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              className="inputtext"
            />
            {formik.touched.name && formik.errors.name && (
              <div className="text-red text-sm">{formik.errors.name}</div>
            )}
          </div>

          <div className="text-G300">
            <label className="block text-sm mb-2">Description</label>
            <input
              type="text"
              name="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              className="inputtext"
            />
          </div>
          <div className="text-G300">
            <label className="block text-sm font-normal mb-2">Combo Items</label>
            <Select
              isMulti
              options={itemOptions}
              isLoading={loading}
              value={itemOptions.filter(option =>
                formik.values.combo_items.includes(option.value)
              )}
              onChange={(selectedOptions) => {
                const selectedIds = selectedOptions?.map(option => option.value);
                formik.setFieldValue("combo_items", selectedIds);
              }}
              placeholder="Select combo items"
            />
          </div>

          <div className="text-G300">
            <label className="block text-sm mb-2">Price</label>
            <div className="relative">
              <span className="absolute inset-y-0 left-3 flex items-center text-green font-semibold">
                ₹
              </span>
              <input
                type="number"
                name="price"
                value={formik.values.price}
                onChange={formik.handleChange}
                onWheel={(e) => e.target.blur()}
                className="inputtext text-green placeholder:text-green"
                placeholder="0"
                style={{ paddingLeft: "25px" }}
              />
            </div>
            {formik.touched.price && formik.errors.price && (
              <div className="text-red text-sm">{formik.errors.price}</div>
            )}
          </div>

          <div className="text-G300">
            <label className="block text-sm mb-2">Status</label>
            <select
              name="status"
              value={formik.values.status}
              onChange={formik.handleChange}
              className="inputtext"
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>

          <div className="text-G300">
            <label className="block text-sm mb-2">Combo Image</label>
            <div className="flex gap-3 items-center">
              <label className="relative w-20 h-20 bg-green50 rounded-full flex items-center justify-center cursor-pointer hover:bg-green-100">
                <icons.IoCloudUploadOutline className="text-green w-7 h-7" />
                <input
                  type="file"
                  accept="image/*"
                  className="absolute inset-0 opacity-0 cursor-pointer"
                  onChange={handleImageChange}
                />
              </label>
              {imagePreview && (
                <img
                  src={imagePreview}
                  alt="Preview"
                  className="w-20 h-20 rounded-full object-cover"
                />
              )}
            </div>
            {formik.touched.image && formik.errors.image && (
              <div className="text-red text-sm mt-1">{formik.errors.image}</div>
            )}
          </div>

          <button
            type="submit"
            disabled={formik.isSubmitting}
            className={`w-full mt-4 h-11 text-lg text-center py-2 rounded-lg font-semibold transition-all ${formik.isSubmitting
                ? "bg-green200 cursor-not-allowed"
                : "bg-green text-white hover:bg-green700"
              }`}
          >
            {formik.isSubmitting ? "Updating..." : " Update Combo"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditCombos;
